<template>
  <div class="py-4 overflow-hidden bg-white rounded shadow">
    <div :style="maxHeightContainerStyle" class="relative">
      <div ref="maxHeightContainer">
        <slot></slot>
      </div>
      <div
        class="absolute bottom-0 left-0 right-0 w-full h-16 white-gradient"
        v-if="canShowMore && !this.isOpen"
      ></div>
    </div>

    <a href="#" @click.prevent="showMore" v-if="canShowMore && !this.isOpen" class="px-4">Show more</a>
    <a href="#" @click.prevent="showLess" v-if="canShowMore && this.isOpen" class="px-4">Show less</a>
    <a href="#" @click.prevent v-else v-html="`&nbsp;`" class="invisible"></a>
  </div>
</template>

<script>
export default {
  props: {
    height: { type: Number, required: true }
  },
  data() {
    return {
      innerContentHeight: 0,
      isOpen: false
    };
  },
  mounted() {
    this.updateHeight();
    window.addEventListener("resize", this.updateHeight);
  },
  updated() {
    this.updateHeight();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateHeight);
  },
  computed: {
    maxHeightContainerStyle: function () {
      return {
        height: this.isOpen ? "initial" : this.height - 16 - 16 + "px",
        maxHeight: this.isOpen ? "initial" : this.height - 16 - 16 + "px",
        overflow: this.isOpen ? "initial" : "hidden"
      };
    },
    canShowMore: function () {
      return this.innerContentHeight + 32 > this.height;
    }
  },
  methods: {
    showMore() {
      this.isOpen = true;
    },
    showLess() {
      this.isOpen = false;
    },
    updateHeight() {
      /**
       * Hacky hack hack
       */
      if (this.$refs.maxHeightContainer.offsetHeight === 0) {
        setTimeout(() => {
          this.updateHeight()
        }, 500);
      } else {
        this.innerContentHeight = this.$refs.maxHeightContainer.offsetHeight;
      }
    }
  }
};
</script>

<style scoped>
.white-gradient {
  background: linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));
}
</style>